import React, { useEffect, useState } from 'react';
import { db } from '../firebase';
import {
  collection,
  query,
  where,
  orderBy,
  getDocs,
  addDoc,
  serverTimestamp
} from 'firebase/firestore';
import { useNavigate } from 'react-router-dom';

const OrderSheet = () => {
  const [stockData, setStockData] = useState([]);
  const [amountNeeded, setAmountNeeded] = useState({});
  const [staffName, setStaffName] = useState('');
  const navigate = useNavigate();
  const storeId = localStorage.getItem('storeId');

  useEffect(() => {
    const fetchStockTake = async () => {
      const q = query(
        collection(db, 'submissions'),
        where('sectionName', '==', 'Stock Take'),
        where('storeId', '==', storeId),
        orderBy('submittedAt', 'desc')
      );
      const snapshot = await getDocs(q);
      if (!snapshot.empty) {
        const latest = snapshot.docs[0].data();
        const formatted = Object.entries(latest.values || {}).map(([label, qty]) => ({
          label,
          qty
        }));
        setStockData(formatted);
      }
    };

    const getStaffName = () => {
      const name = localStorage.getItem('staffName');
      if (name) setStaffName(name);
    };

    fetchStockTake();
    getStaffName();
  }, [storeId]);

  const handleInputChange = (label, value) => {
    setAmountNeeded(prev => ({ ...prev, [label]: value }));
  };

  const handleSave = async () => {
    try {
      const rows = stockData.map(item => {
        const [section, rawItem] = item.label.split(' - ');
        return {
          section: section?.trim() || '',
          item: rawItem?.trim() || '',
          currentQty: Number(item.qty),
          neededQty: Number(amountNeeded[item.label]) || 0
        };
      });

      await addDoc(collection(db, 'orderSheets'), {
        submittedAt: serverTimestamp(),
        submittedBy: staffName,
        storeId,
        rows
      });

      alert('Order sheet saved successfully.');
      navigate('/staff-dashboard');
    } catch (error) {
      console.error('Save failed:', error);
      alert('Error saving order sheet.');
    }
  };

  return (
    <div style={{ padding: '30px', maxWidth: '900px', margin: '0 auto' }}>
      <h2 style={{ textAlign: 'center' }}>🧾 Order Sheet</h2>
      <p style={{ textAlign: 'center' }}>Based on the most recent Stock Take</p>

      <table style={{ width: '100%', borderCollapse: 'collapse', marginTop: '20px' }}>
  <thead>
    <tr>
      <th style={{ textAlign: 'left', borderBottom: '2px solid #ccc', padding: '10px' }}>Item</th>
      <th style={{ textAlign: 'right', borderBottom: '2px solid #ccc', padding: '10px' }}>In Stock</th>
      <th style={{ textAlign: 'right', borderBottom: '2px solid #ccc', padding: '10px' }}>Amount Needed</th>
    </tr>
  </thead>
  <tbody>
    {stockData.map((item, idx) => (
      <tr key={idx} style={{ borderBottom: '1px solid #eee' }}>
        <td style={{ padding: '10px', verticalAlign: 'top', borderRight: '1px solid #eee' }}>
          {item.label}
        </td>
        <td style={{
          padding: '10px',
          textAlign: 'right',
          verticalAlign: 'top',
          borderRight: '1px solid #eee'
        }}>
          <strong>{item.qty}</strong>
        </td>
        <td style={{ padding: '10px', textAlign: 'right', verticalAlign: 'top' }}>
          <input
            type="number"
            value={amountNeeded[item.label] || ''}
            onChange={(e) => handleInputChange(item.label, e.target.value)}
            style={{
              width: '80px',
              padding: '6px',
              borderRadius: '4px',
              border: '1px solid #ccc',
              textAlign: 'right',
              backgroundColor: '#f9f9f9'
            }}
          />
        </td>
      </tr>
    ))}
  </tbody>
</table>


      <div style={{ textAlign: 'center', marginTop: '30px' }}>
        <button
          onClick={handleSave}
          style={{
            backgroundColor: '#28a745',
            color: 'white',
            padding: '10px 20px',
            border: 'none',
            borderRadius: '6px',
            fontWeight: 'bold',
            cursor: 'pointer'
          }}
        >
          ✅ Save Order Sheet
        </button>
        <button
          onClick={() => navigate('/staff-dashboard')}
          style={{
            backgroundColor: '#6c757d',
            color: 'white',
            padding: '10px 20px',
            border: 'none',
            borderRadius: '6px',
            marginLeft: '15px',
            cursor: 'pointer'
          }}
        >
          ← Back
        </button>
      </div>
    </div>
  );
};

export default OrderSheet;
